// extracted by mini-css-extract-plugin
export default {"container":"fd_container__u5GSu","breadCrumb":"fd_breadCrumb__Nq+M6"};